export default "__VITE_ASSET__CINb45GL__"